<template>
  <!--头部导航区域-->
  <div class="header_conter">
    <nav class="header_box">
      <img v-if="isAlibabaSite" :src="tongToolUrl" style="vertical-align: middle" width="240" height="21">
      <img v-else :src="logoUrl" style="cursor: pointer;vertical-align: middle" width="210" height="22" @click="toShoping" :alt="$t('key1000009')">
      <div class="navbar_nav" v-if="!isAlibabaSite">
        <span class="txt" @click="toShoping">{{ $t('key1006562') }}</span>
        <template v-if="systemEnvironmentType === 'yms'">
          <span class="h-line">|</span>
          <span class="txt" @click="$refs.gettingStarted.open()">{{ $t('key1000094') }}</span>
        </template>
      </div>
    </nav>
    <gettingStarted ref="gettingStarted"></gettingStarted>
  </div>
</template>

<script>
import {commonLocalStorage, getSystemDomainNameData, handleLogoUrl} from "@/utils/common";
import gettingStarted from '@/components/common/gettingStarted';

export default {
  name: "login-header",
  props: {
    isAlibabaSite: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      tongToolUrl: require('@/assets/images/tongTool.png'),
      distributorDomain: null,
    };
  },
  computed: {
    logoUrl() {
      return handleLogoUrl()
    },
    systemEnvironmentType() {
      let pageConfig = commonLocalStorage.getItem('pageConfig') || this.$store.state.pageConfig;
      return pageConfig?.systemEnvironment;
    }
  },
  created() {
    getSystemDomainNameData().then((data) => {
      if (data) {
        let {distributorDomain} = data;
        this.distributorDomain = distributorDomain;
      }
    });
  },
  methods: {
    // 点击logo图片时，跳转到商城首页
    toShoping() {
      window.location.href = this.distributorDomain;
      // pageJump('/index.html#/index', '/yms-shopping-service', '_self');
    },
  },
  components: {
    gettingStarted
  }
};
</script>

<style lang="less" scoped>
@import "src/assets/styles/shopping/common";

.header_conter {
  background-color: #fff;
  width: 100%;
  border-bottom: solid 1px #ededed;
}

.header_box {
  margin: 0 auto;
  height: 70px;
  width: 1140px;
  display: flex;
  justify-content: space-between;
  align-items: center;
  box-sizing: border-box;

  .navbar_nav {
    display: flex;
    align-items: center;

    .txt {
      display: inline-block;
      color: #7d8694;
      height: 50px;
      line-height: 50px;
      padding: 0 25px;
      vertical-align: center;
      margin-top: 10px;
      cursor: pointer;

      &:hover {
        color: @subject_color;
      }
    }

    .h-line {
      display: inline-block;
      height: 50px;
      line-height: 58px;
    }
  }
}
</style>
